import React, {useMemo} from 'react';
import {AppBar, Box, Link, Stack, Toolbar, useTheme} from '@mui/material';
import {useNavigate} from 'react-router';
import type {FCWithChildren} from 'types';
import {Logo} from 'components/svg';

export const AppAnon: FCWithChildren = ({children}) => {
  const bodySx = useMemo(
    () => ({
      width: '100vw',
      height: '100vh',
    }),
    [],
  );
  const wrapperSx = useMemo(
    () => ({
      display: 'flex',
      justifyContent: 'center',
      mt: 10,
    }),
    [],
  );
  const navigate = useNavigate();
  const {palette} = useTheme();

  const AnonAppBar = useMemo(() => {
    return (
      <AppBar
        position="static"
        sx={{
          backgroundClip: 'padding-box',
        }}>
        <Toolbar
          disableGutters
          sx={{
            paddingX: 3,
            justifyContent: 'space-between',
          }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: 'center',
            }}>
            <Link onClick={() => navigate('/')} className={'pointer'}>
              <Logo color={palette.primary.contrastText} />
            </Link>
          </Stack>
        </Toolbar>
      </AppBar>
    );
  }, [navigate, palette]);

  return (
    <div style={bodySx}>
      {AnonAppBar}

      <Box sx={wrapperSx}>{children}</Box>
    </div>
  );
};
